module.exports = __webpack_public_path__ + "img/17.51b05ac3.png";